/* eslint-disable react/no-array-index-key */
import React, { useState, FC } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import HtmlImg from '../../static/assets/landing/react.svg';
import CssImg from '../../static/assets/landing/angular.svg';
import JsImg from '../../static/assets/landing/vue.svg';
import ReactImg from '../../static/assets/landing/REST.svg';
import GitImg from '../../static/assets/homepage/icon-git.svg';
import GitHubImg from '../../static/assets/landing/GQL.svg';
import TsImg from '../../static/assets/landing/figma.svg';
import SassImg from '../../static/assets/landing/WS.svg';
import './HomeSyllabus.scss';

type TabItem = {
	title: string;
	duration: string;
	content: string;
};

type TabProps = {
	tabItem: TabItem;
	activeTab: string;
	handleTabClick: (tab: string) => void;
};

const Tab: FC<TabProps> = ({ tabItem, activeTab, handleTabClick }) => (
	<div
		className={`home-syllabus__body-items-row ${
			activeTab === tabItem.title ? 'active' : ''
		}`}
		onClick={() => handleTabClick(tabItem.title)}
	>
		<div className="home-syllabus__body-item-name">{tabItem.title}</div>
		<div className="home-syllabus__body-item-duration">{tabItem.duration}</div>
	</div>
);

type TabContentProps = {
	tabItem: TabItem;
	activeTab: string;
};

const TabContent: FC<TabContentProps> = ({ tabItem, activeTab }) => {
	const key = tabItem.title;
	const content = tabItem.content.split('<br>');
	return activeTab === tabItem.title ? (
		<div className="home-syllabus__body-description-item" key={key}>
			<h3 className="home-syllabus__body-description-title title title title-medium">
				{tabItem.title}
			</h3>
			<div className="home-syllabus__body-description-text">
				{content.map((item, index) => (
					<div key={index}>{item}</div>
				))}
			</div>
		</div>
	) : null;
};

const TabItems: TabItem[] = [
	{
		title: 'User authentication',
		duration: 'Beginner',
		content:
			'Authentication is one of the most important things in every web application. We have apis for user registration, login, user activation after registration, refresh token and forgot password flows',
	},
	{
		title: 'Regular CRUD',
		duration: 'Beginner',
		content:
			'Create, read, update, delete actions are still the pillars of any web application. You will learn how to post something, update it, remove it and display it. Based on user authentication the relation between user and posted entity creates exact classic problem as you can face everywhere on your professional way.',
	},
	{
		title: 'Infinite scroll and paging',
		duration: 'Intermediate',
		content:
			'The problem of pagination and loading entities from api while scrolling are the most common patterns in modern development.',
	},
	{
		title: 'Data visualization',
		duration: 'Intermediate',
		content:
			'There are a lot of B2B companies today in the market anda data visualization is the common problem for dashboards or report pages. Charts and tables are the most popular ways to display data and certainly worth attention during your training.',
	},
	{
		title: 'Web Sockets real-time messaging',
		duration: 'Intermediate',
		content:
			'Real-time messaging with Web Socket technology is very popular solution which you can face in chats, quizes, games and complicated data renderings. This is always challenging to work with it and our APIs give you this opportunity!',
	},
	{
		title: 'GraphQL',
		duration: 'Advanced',
		content:
			'Today this technology is very common in the community and in any level companies. It is very hard to understand how to deal with it theoretically, so we provide the engine to learn how to communicate with server via GraphQL technology.',
	},
	{
		title: 'Reactions',
		duration: 'Beginner',
		content:
			'In every social application we can find likes and dislikes, it becomes common way to get a fast reaction from the user. It looks simple, however it has certain patterns in its implementation.',
	},
	{
		title: 'Nested comments',
		duration: 'Beginner',
		content:
			'Similarly to reactions, comments and their responses is also a very common flow in social applications. This pattern is also crucial to understand.',
	},
	{
		title: 'Editable tables',
		duration: 'Intermediate',
		content:
			'Tables are common components of any B2B web applications. Dealing with tables has its specificity and certain approaches, especially if you have editable table cells.',
	},
];

const HomeSyllabus = () => {
	const [expandedPanel, setExpandedPanel] = useState<string | false>(false);

	const handleChange =
		(panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
			setExpandedPanel(isExpanded ? panel : false);
		};

	const [activeTab, setActiveTab] = useState(TabItems[0].title);

	const handleTabClick = (tab: React.SetStateAction<string>) => {
		setActiveTab(tab);
	};

	return (
		<section className="home-syllabus home-section">
			<div className="internal-wrapper">
				<div className="home-section-header">
					<h2 className="home-plans__title title-section title">Our use cases</h2>
					<p className="home-plans__subtitle subtitle-section">
						Get prepared for real world applications
					</p>
				</div>
				<div className="home-syllabus__body-wrapper">
					<div className="home-syllabus__body">
						<div className="home-syllabus__body-header">
							<div className="home-syllabus__body-header-left">
								<div className="home-syllabus__body-header-course">Use case</div>
								<div className="home-syllabus__body-header-duration"> </div>
							</div>
							<div className="home-syllabus__body-header-left-right">Description</div>
						</div>
						<div className="home-syllabus__body-items-wrapper">
							<div className="home-syllabus__body-items-rows-wrapper">
								{TabItems.map((item) => (
									<Tab
										key={item.title}
										activeTab={activeTab}
										tabItem={item}
										handleTabClick={handleTabClick}
									/>
								))}
							</div>

							<div className="home-syllabus__body-description-wrapper">
								{TabItems.map((item) => (
									<TabContent key={item.title} activeTab={activeTab} tabItem={item} />
								))}
							</div>
						</div>

						<div className="home-syllabus__mobile-items-wrapper">
							{TabItems.map((item) => (
								<div className="home-syllabus__mobile-item">
									<Accordion
										expanded={expandedPanel === item.title}
										onChange={handleChange(item.title)}
										elevation={0}
									>
										<AccordionSummary
											aria-controls="panel1a-content"
											className={`home-faq__item-header home-syllabus__mobile__item-header ${
												expandedPanel === item.title ? 'opened' : ''
											}`}
										>
											<p className="home-syllabus__mobile__item-header-text">
												{item.title}
											</p>
											<div className="home-syllabus__mobile__item-header-duration">
												{item.duration}
											</div>
										</AccordionSummary>
										<AccordionDetails className="home-faq__item-text-wrapper home-syllabus__mobile__item-text-wrapper">
											<div className="home-faq__item-text text-block home-syllabus__mobile__item-text-wrapper">
												{item.content}
											</div>
										</AccordionDetails>
									</Accordion>
								</div>
							))}
						</div>
					</div>
					<div className="home-syllabus__footer">
						<div className="home-syllabus__footer-button button button-standard">
							Try Codeway free
						</div>
						{/* <div className="home-syllabus__footer-common-duration">
							<span className="home-syllabus__footer-common-duration-title">
								Total duration
							</span>{' '}
							<span className="home-syllabus__footer-common-duration-weeks">
								18-32 weeks
							</span>
						</div> */}
						<div className="home-syllabus__footer-icons-wrapper">
							<img
								className="home-syllabus__footer-icon"
								src={HtmlImg}
								alt="Codeway.TODAY"
							/>
							<img
								className="home-syllabus__footer-icon"
								src={CssImg}
								alt="Codeway.TODAY"
							/>
							<img
								className="home-syllabus__footer-icon"
								src={JsImg}
								alt="Codeway.TODAY"
							/>
							<img
								className="home-syllabus__footer-icon"
								src={ReactImg}
								alt="Codeway.TODAY"
							/>
							<img
								className="home-syllabus__footer-icon"
								src={GitImg}
								alt="Codeway.TODAY"
							/>
							<img
								className="home-syllabus__footer-icon"
								src={GitHubImg}
								alt="Codeway.TODAY"
							/>
							<img
								className="home-syllabus__footer-icon"
								src={TsImg}
								alt="Codeway.TODAY"
							/>
							<img
								className="home-syllabus__footer-icon"
								src={SassImg}
								alt="Codeway.TODAY"
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default HomeSyllabus;
